<div style="width:40vw;height:85vh">
<div fxLayout="row" fxLayoutAlign="end center" >
    <mat-icon style="cursor: pointer;" (click)="closePopup()">close</mat-icon>
</div>
<div id="carouselExampleControlsNoTouching" class="carousel slide" data-bs-touch="false" data-bs-ride="false">
    <div class="carousel-inner">
        <div class="carousel-item text-center" *ngFor="let doc of previewDocuments;let i=index"
            [ngClass]="{'active':i==0}">
            <img [src]="doc.url" style="width:70%" alt="..." >
        </div>

    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControlsNoTouching"
        data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"> </span>
        <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControlsNoTouching"
        data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
    </button>
</div>
</div>